import { keys as parentKeys } from '@copro/api';

const quotes = [...parentKeys.all, 'quote-comparisons'] as const;

export const keys = {
  quotes,

  groupsList: (spaceId: string) => [...quotes, 'list', spaceId] as const,
  group: (groupId: string) => [...quotes, 'detail', groupId] as const,
  columns: (groupId: string) => [...keys.group(groupId), 'columns'] as const,
  groupQuotes: (groupId: string) => [...keys.group(groupId), 'quotes'] as const,
};
